/**
 * 工單轉倉表單緩存固定常數（不可自由拼接 scope）。
 * @see docs/API_SYSTEM_FORM_CACHE.md
 * @see chenyo-erp-v2_backend-docs …/form-cache-frontend-handoff.md
 */

/** Public scope key（第一階段唯一） */
export const WORK_ORDER_STOCK_TRANSFER_CACHE_SCOPE =
  'mom-work-order-stock-transfer-create';

/** 僅支援 payload_version = 1 */
export const WORK_ORDER_STOCK_TRANSFER_CACHE_PAYLOAD_VERSION = 1;

/** Canonical UTF-8 payload 上限（bytes） */
export const WORK_ORDER_STOCK_TRANSFER_CACHE_MAX_BYTES = 262144;

/** 正式 create 可選 header（cache-aware） */
export const FORM_CACHE_SNAPSHOT_HEADER = 'X-Form-Cache-Snapshot-Id';
